import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { getMatAnalysis } from "@/api/php/player";
import { onMounted, ref } from "vue";
// import AnalysisMatchBasket from "@/model/AnalysisMatchBasket";
import AnalysisBasket from "@/model/AnalysisBasket";
import { formatDateTime } from "@/uitls/uitls";
import { useI18n } from 'vue-i18n'
interface dataProps {
    id: any;
    type: any
}

export default /*#__PURE__*/_defineComponent({
  name: 'BasketBallFenxi',
  props: {
    id: { type: null, required: true },
    type: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    id: any;
    type: any
}

_useCssVars(_ctx => ({
  "5fc93dc6-primaryColor": (_unref(primaryColor))
}))

const { t } = useI18n()


onMounted(() => {
    getData()
});
//同赛事
// const recentSameLeague = ref(false)
//同主客
const recentHomeSide = ref(false)
//同主客
const recentSameSide = ref(false)
//主队名字
const homeName = ref('')
//福队名字
const awayName = ref('')
const selType = ref(0);
const data = ref(null)

const historyData = ref([])

const analysis = ref()

const homeList = ref([])
const awayList = ref([])
//获取数据
const getData = async () => {
    console.log(props.type, props.id);
    const res: any = await getMatAnalysis({ type_id: props.type, id: props.id })

    if (res && res.code == 200) {
        data.value = new AnalysisBasket(res.data)
        let history = data.value.getHistory(recentHomeSide.value);
        analysis.value = data.value.getAnalysisCount(history, !recentSameSide.value);
        // console.log(analysis.value);
        history = history.slice(0, 5);
        historyData.value = history

        homeName.value = data.value.getMatchHomeName();

        awayName.value = data.value.getMatchAwayName();

        homeList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
        awayList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
    }


}

const _onRecentHomeSide = () => {
    recentHomeSide.value = !recentHomeSide.value
    let history = data.value.getHistory(recentHomeSide.value);
    analysis.value = data.value.getAnalysisCount(history, !recentSameSide.value);
    history = history.slice(0, 5);
    historyData.value = history
    homeName.value = data.value.getMatchHomeName();
    awayName.value = data.value.getMatchAwayName();
    homeList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
    awayList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
}
const onrecentSameSide = () => {
    recentSameSide.value = !recentSameSide.value
    let history = data.value.getHistory(recentHomeSide.value);
    analysis.value = data.value.getAnalysisCount(history, !recentSameSide.value);
    history = history.slice(0, 5);
    historyData.value = history
    homeName.value = data.value.getMatchHomeName();
    awayName.value = data.value.getMatchAwayName();
    homeList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
    awayList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
}

const changeType = (val) => {
    selType.value = val;
    homeList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
    awayList.value = data.value.getRecent(selType.value == 0, recentSameSide.value, !recentSameSide.value);
}

const getname = (match) => {
    let homecolor = '#0D0D0D';
    let awaycolor = '#0D0D0D';
    if (match.homeScore > match.awayScore) {
        if (match.isHome) {
            homecolor = '#FC2E34';
            awaycolor = '#0D0D0D';
        } else {
            homecolor = '#0D0D0D';
            awaycolor = '#1692E1';
        }
    } else if (match.homeScore < match.awayScore) {
        if (match.isHome) {
            homecolor = '#1692E1';
            awaycolor = '#0D0D0D';
        } else {
            homecolor = '#0D0D0D';
            awaycolor = '#FC2E34';
        }
    } else {
        if (match.isHome) {
            homecolor = '#34CF16';
            awaycolor = '#0D0D0D';
        } else {
            homecolor = '#0D0D0D';
            awaycolor = '#34CF16';
        }
    }
    return {
        homecolor, awaycolor
    }
}





const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;

const __returned__ = { t, props, recentHomeSide, recentSameSide, homeName, awayName, selType, data, historyData, analysis, homeList, awayList, getData, _onRecentHomeSide, onrecentSameSide, changeType, getname, primaryColor, formatDateTime }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})